export const pushDataLayerEvent = (eventName: string) => {
  if ('dataLayer' in window && Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: eventName });
  }
};